import * as React from 'react';

import './popover.scss';

export interface PopOverProps {
	opened?: boolean;
	width?: string;
	left?: string;
	onDismiss?: () => void;
}

export class PopOver extends React.Component<PopOverProps, any> {
	root: HTMLElement;
	constructor(props: PopOverProps) {
		super(props);
		this.state = { show: this.props.opened, top: null, left: props.left };
	}

	renderPopOver() {
		if (!this.state.show) return null;
		var style = {
			top: this.state.top ? this.state.top + 'px' : null,
			left: this.state.left ? this.state.left : null,
			width: this.props.width ? this.props.width : 'auto',
			marginLeft: this.props.width && !isNaN(parseFloat(this.props.width)) ? -parseFloat(this.props.width) / 2 : null,
		};
		return (
			<div className='l-popover' style={style}>
				<div className='l-popover-header'>
					<i className='fa fa-close' onClick={this.close.bind(this)}></i>
				</div>
				<div className='l-popover-content'>{this.props.children}</div>
			</div>
		);
	}

	close() {
		if (this.props.onDismiss) {
			this.props.onDismiss();
		} else {
			this.setState({ show: false });
		}
	}

	componentWillReceiveProps(nextProps: PopOverProps) {
		this.setState({ show: nextProps.opened });
	}

	render() {
		return <div>{this.renderPopOver()}</div>;
	}
}
export default PopOver;
